export default {
  "gatehouse": "Portone",
  "openControlPanel": "Pannello di controllo aperto",
  "totalAccess": "Accesso totale",
  "deniedAccess": "Accesso negato",
  "activeAlerts": "Avvisi attivi",
  "openIncidents": "Incidenti aperti",
  "highRisk": "Rischio alto",
  "accessLogHistory": "Accedi alla cronologia dei log",
  "refresh": "Aggiorna",
  "export": "Esportazione",
  "searchByMemberNameOrZone": "Cerca per nome o zona socio...",
  "status": "Stato",
  "allStatus": "Tutti gli stati",
  "granted": "Sovvenzione",
  "denied": "Negato",
  "zone": "Zona",
  "allZones": "Tutte le zone",
  "method": "Metodo",
  "allMethods": "Tutti i metodi",
  "member": "Socio",
  "time": "Ora",
  "riskLevel": "Livello di rischio",
  "notes": "Note",
  "noAccessLogsFoundMatchingYourCriteria": "Nessun log di accesso trovato corrispondente ai tuoi criteri",
  "cameraEventTimeline": "Timeline evento della macchina fotografica",
  "exportView": "Vista dell'esportazione",
  "searchByCameraName": "Ricerca per nome della macchina fotografica...",
  "eventType": "Tipo di evento",
  "allEventTypes": "Tutti i tipi di eventi",
  "person": "Persona",
  "vehicle": "Veicolo",
  "motion": "MOVIMENTO",
  "doorbell": "Campana porta",
  "loadingEvents": "Caricamento eventi...",
  "noEventsFoundMatchingCriteria": "Nessun evento trovato criteri di corrispondenza.",
  "eventThumbnail": "Miniatura dell'evento",
  "playback": "Riproduzione",
  "createIncident": "Creare Incident",
  "offline": "OFFLINE",
  "loadingCameras": "Caricamento di telecamere...",
  "cameraWall": "Camera da letto",
  "grid": "Griglia",
  "accessControlScanner": "Scanner di controllo di accesso",
  "scanQrCodeRfidOrEnterMembershipNumber": "Scansione del codice QR, RFID, o inserire il numero di adesione...",
  "clear": "Cancella",
  "staffOverride": "Sovraccarico del personale",
  "gateCameras": "Telecamere di cancello",
  "recentGateActivity": "Attivitá del cancello recente",
  "expectedArrivals": "Arrivi previsti",
  "noExpectedArrivalsToday": "Nessun arrivo previsto oggi",
  "quickActions": "Azioni rapide",
  "reportIncident": "Rapporto Incidente",
  "viewLiveCameras": "Visualizza fotocamere dal vivo",
  "emergencyOverride": "Override di emergenza",
  "incidentManagement": "Gestione dell'incidenza",
  "trackAndManageSecurityIncidentsAndReports": "Tracciare e gestire gli incidenti e i report di sicurezza",
  "searchIncidents": "Incidenti di ricerca...",
  "severity": "Severità",
  "allSeverity": "Tutta la severità",
  "type": "Tipo",
  "allTypes": "Tutti i tipi",
  "view": "Visualizza",
  "update": "Aggiornamento",
  "actionsTaken": "Azioni prese:",
  "witnesses": "Testimoni:",
  "followupRequired": "Richiesta di follow-up",
  "noIncidentsFoundMatchingYourCriteria": "Nessun incidente trovato corrispondente ai tuoi criteri",
  "incidentReportingFormWouldBeImplementedHere": "Il modulo di segnalazione incidente dovrebbe essere implementato qui.",
  "close": "Chiudi",
  "securityAlerts": "Avvisi di sicurezza",
  "searchAlerts": "Allarmi di ricerca...",
  "allRisk": "Tutti i rischi",
  "alertType": "Tipo di allarme",
  "acknowledge": "Riconoscimento",
  "resolve": "Risolvere",
  "recommendedAction": "Azione consigliata:",
  "resolutionNotes": "Note di risoluzione:",
  "noSecurityAlertsFoundMatchingYourCriteria": "Nessun avviso di sicurezza trovato corrispondente ai tuoi criteri",
  "recentAccessActivity": "Attività di accesso recenti",
  "prioritySecurityAlerts": "Avvisi di sicurezza prioritari",
  "noHighpriorityAlerts": "Nessun allarme ad alta priorità",
  "accessTrends7Days": "Tendenze di accesso (7 giorni)",
  "zoneAccessDistribution": "Distribuzione di accesso a zone",
  "alertRiskLevels": "Avviso livelli di rischio",
  "zoneStatusOverview": "Panoramica sullo stato della zona",
  "bookingRequired": "Prenotazione richiesta",
  "unifiProtectIntegration": "Integrazione UniFi Protect",
  "connected": "Collegato",
  "disconnected": "Scollegato",
  "totalCameras": "Fotocamere totali",
  "online": "Online Online",
  "recording": "Registrazione:",
  "motionAlerts": "Avvisi di movimento",
  "cameraLocations": "Località della macchina fotografica",
  "fullscreen": "Schermo completo",
  "cameraOffline": "Macchina fotografica Offline",
  "rec": "RECOLAZIONE",
  "play": "Gioca",
  "stop": "Fermati.",
  "model": "Modello:",
  "ipAddress": "Indirizzo IP:",
  "nightVision": "Visione notturna:",
  "selectACameraToViewLiveFeed": "Selezionare una fotocamera per visualizzare il feed dal vivo",
  "unifiIntegrationSettings": "Impostazioni di integrazione UniFi",
  "unifiConsoleIp": "Console IP uniFi",
  "username": "Nome utente",
  "apiKey": "API chiave",
  "testConnection": "Connessione di prova",
  "saveSettings": "Salvare le impostazioni",
  "zoneManagement": "Gestione delle zone",
  "configureAccessPermissionsAndSettingsForDifferentClubZones": "Configurare i permessi di accesso e le impostazioni per diverse zone del club",
  "addZone": "Aggiungi zona",
  "capacity": "Capacità",
  "hours": "Ore",
  "allowedMemberships": "Consentito Memberships",
  "allMembers": "Tutti i soci",
  "emergencyOverrideActive": "Override di emergenza attiva",
  "active": "Attivo",
  "edit": "Modifica",
  "zoneConfigurationFormWouldBeImplementedHere": "Il modulo di configurazione delle zone sarebbe implementato qui",
  "inactive": "Inattivo",
  "enabled": "Abilitato",
  "disabled": "Disabilitato",
  "editZone": "Modifica della zona",
  "addNewZone": "Aggiungi nuova zona",
  "editIncident": "Modifica Incidente",
  "reportNewIncident": "Rapporto Nuovo Incidente",
  "scanning": "Scansione...",
  "scan": "Scansione",
  "selectCamera": "Selezionare la fotocamera",
  "live": "IN DIRETTA",
  "unlimited": "Illimitata",
  "low": "Basso",
  "medium": "Medio",
  "high": "Alto",
  "critical": "Critico",
  "device": "Dispositivo: {id}",
  "anomaliesOne": "{count} anomalia",
  "anomaliesOther": "{count} anomalie",
  "accessSummary": "Mostrando {shown} di {total} log di accesso",
  "alertsSummary": "Mostrando {shown} di {total} avvisi",
  "incidentsSummary": "Mostrando {shown} di {total} incidenti",
  "grantedCount": "Concessa: {count}",
  "deniedCount": "Negato: {count}",
  "activeCount": "Attivo: {count}",
  "acknowledgedCount": "Riconosciuto: {count}",
  "resolvedCount": "Risolto: {count}",
  "openCount": "Aperto: {count}",
  "investigatingCount": "Investigazione: {count}",
  "confidence": "{count} % di fiducia",
  "acknowledgedBy": "Riconosciuto da {name}",
  "reportedBy": "Segnalato da: {name}",
  "involves": "Fatturato: {name}",
  "photosOne": "{count} foto allegata",
  "photosOther": "{count} foto allegate",
  "riskLabel": "{level} rischio",
  "severityLabel": "{level} severità",
  "memberIdentity": "{type} socio # {number}",
  "visiting": "Visite: {name}",
  "host": "Ospite: {name}",
  "expected": "previsto: {time}",
  "accessGranted": "Accesso concesso",
  "accessDenied": "Accesso negato",
  "capacitySummary": "Capacità: {current} / {max}",
  "accessHours": "Accesso: {start} - {end}",
  "liveFeed": "Alimentazione dal vivo: {name}",
  "lastMotion": "Ultimo movimento: {time}",
  "validMembership": "Affiliazione valida",
  "inactiveMembership": "Abbonamento inattivo",
  "validVisitorPass": "Passata del visitatore valida",
  "invalidVisitorPass": "Pass per i visitatori non validi",
  "invalidScanCode": "Codice di scansione non valido",
  "systemError": "Errore di sistema",
  "overrideApproved": "Interruzione del personale approvato",
  "loadError": "Non è possibile caricare i dati di sicurezza.",
  "dateUnavailable": "Data non disponibile",
  "noCameras": "Nessuna telecamera disponibile",
  "fullscreenCamera": "Visualizzare la fotocamera a schermo intero",
  "pauseCamera": "Pause vista dal vivo",
  "playCamera": "Giocare in diretta",
  "muteCamera": "Mute fotocamera",
  "unmuteCamera": "Fotocamera senza fine",
  "eventDate": "Data dell'evento",
  "settings": "Impostazioni",
  "accessCount": "Conto di accesso",
  "enums": {
    "status": {
      "granted": "concesso",
      "denied": "negato",
      "active": "attivo",
      "inactive": "inattivo",
      "acknowledged": "riconosciuto",
      "resolved": "risolto",
      "dismissed": "respinto.",
      "open": "aperto",
      "investigating": "indagare su",
      "closed": "chiuso chiuso",
      "online": "online",
      "offline": "linea offline",
      "maintenance": "manutenzione"
    },
    "risk": {
      "low": "basso",
      "medium": "media media",
      "high": "alto",
      "critical": "critico critico"
    },
    "severity": {
      "low": "basso",
      "medium": "media media",
      "high": "alto",
      "critical": "critico critico"
    },
    "method": {
      "qr_code": "codice qr",
      "manual_override": "override manuale",
      "rfid": "rfio"
    },
    "event": {
      "person": "persona",
      "vehicle": "veicolo",
      "motion": "movimento",
      "doorbell": "Campana porta"
    }
  },
  "cameraIncidentDescription": "Incidente basato su {type} rilevamento a {camera} ."
};
